
export const $awsConfig = {
   "Auth": {
      "region": "us-east-1",
      "userPoolId": "us-east-1_6a3mLgFwb",
      "userPoolWebClientId": "6tcks2cenf2pdu9o4g9arvog8s",
   },
}
